import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../../config.service';
import { AESService } from '../../encryption/aes.service';

@Injectable()
export class CreateAttributesService {

  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
   
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  attributeCreate(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/attribute/createAttribute', user, this.httpOptions)
      .map((res) => { return res }

      );
  }
}
